// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"76c8444e","420":"b122e5f4","450":"acc4ebed","884":"ae2f26aa"}[chunkId] + ".chunk.js";
};